(function () {
  'use strict';

  // Keep the cart badge(s) live no matter how "Add to cart" / quantity
  // changes are wired up on the page. We watch every fetch() call the
  // page makes; whenever one hits a cart-mutating endpoint and succeeds,
  // we update the badge. /cart/change.js and /cart/update.js already
  // return the full cart object (with item_count) in their own response,
  // so we read that directly instead of firing a second request — this
  // avoids the race where a fast follow-up fetch to /cart.js could
  // resolve out of order and paint a stale count (e.g. rapid +/- clicks
  // on the quantity stepper). /cart/add.js only returns the added line
  // item, not the cart total, so for that one we fall back to fetching
  // /cart.js — guarded by a request token so only the most recent
  // fallback fetch is ever allowed to update the badge.
  var originalFetch = window.fetch;
  var cartFetchToken = 0;

  function updateCartBadges(count) {
    if (typeof count === 'undefined' || count === null) return;
    var countEls = document.querySelectorAll('.kd-sidebar__cart-badge, .kd-mobile-bar__cart-badge');
    countEls.forEach(function (el) {
      el.textContent = count;
    });
  }

  function fetchLatestCartCount() {
    var token = ++cartFetchToken;
    originalFetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (token !== cartFetchToken) return; // a newer request already landed — ignore this stale one
        updateCartBadges(cart.item_count);
      })
      .catch(function () {});
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var request = originalFetch.apply(this, arguments);
      var target = arguments[0];
      var url = typeof target === 'string' ? target : (target && target.url) || '';

      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        request
          .then(function (response) {
            if (!response || !response.ok) return;
            cartFetchToken += 1; // any in-flight fallback fetches are now stale
            return response
              .clone()
              .json()
              .then(function (data) {
                if (data && typeof data.item_count !== 'undefined') {
                  updateCartBadges(data.item_count);
                } else {
                  fetchLatestCartCount();
                }
              })
              .catch(fetchLatestCartCount);
          })
          .catch(function () {
            // Silently ignore — worst case the badge stays as-is until
            // the next natural update.
          });
      }

      return request;
    };
  }

  var sidebar = document.querySelector('[data-kd-sidebar]');
  var overlay = document.querySelector('[data-kd-sidebar-overlay]');
  var openBtn = document.querySelector('[data-kd-sidebar-open]');
  var closeBtn = document.querySelector('[data-kd-sidebar-close]');

  if (!sidebar) return;

  // Cart icon(s) should open the cart drawer instead of navigating to
  // the cart page. Standard Dawn pattern: intercept the click, prevent
  // the default navigation, and call the <cart-drawer> element's
  // open() method. Falls back to toggling the drawer's active class
  // directly if open() isn't available for some reason, and finally
  // falls back to letting the link navigate normally if no drawer
  // exists on the page at all.
  function openCartDrawer(event) {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
      event.preventDefault();
      cartDrawerEl.open();
      return;
    }
    var cartDrawerRoot = document.getElementById('CartDrawer-Root');
    if (cartDrawerRoot) {
      event.preventDefault();
      document.body.classList.add('overflow-hidden');
      // Double rAF: ensures the browser paints the drawer in its closed
      // position first, so adding "active" a frame later actually
      // triggers the CSS transition instead of jumping instantly.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cartDrawerRoot.classList.add('active');
        });
      });
    }
    // If neither exists, do nothing — the link falls through to its
    // normal href and navigates to the cart page.
  }

  var cartTriggers = document.querySelectorAll('.kd-sidebar__cart-icon, .kd-mobile-bar__cart');
  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openCartDrawer);
  });

  // Fixed mobile top bar needs the page pushed down by its own height,
  // since position:fixed takes it out of normal document flow.
  var mobileBar = document.querySelector('[data-kd-mobile-bar]');

  function syncMobileBarSpacing() {
    if (!mobileBar) return;
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.body.style.removeProperty('padding-top');
      return;
    }
    document.body.style.paddingTop = mobileBar.offsetHeight + 'px';
  }

  syncMobileBarSpacing();
  window.addEventListener('resize', syncMobileBarSpacing);

  function isMobileViewport() {
    return !window.matchMedia('(min-width: 990px)').matches;
  }

  function openSidebar() {
    sidebar.classList.add('is-open');
    overlay.classList.add('is-visible');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('kd-sidebar-locked');
  }

  function resetNavPanels() {
    var openPanels = sidebar.querySelectorAll('[data-kd-panel]:not(.kd-nav-panel--root).is-active');
    openPanels.forEach(function (panel) {
      panel.classList.remove('is-active');
    });
    var openChevrons = sidebar.querySelectorAll('.kd-nav-chevron-btn.is-open');
    openChevrons.forEach(function (chevronBtn) {
      chevronBtn.classList.remove('is-open');
    });
  }

  // Full search panel — takes over the sidebar's box (input + close button).
  // Two triggers exist: the in-sidebar footer button, and the closed-state
  // mobile top bar's search icon. Both share the data-kd-search-open
  // attribute, so bind every match found in the document.
  var searchOpenBtns = document.querySelectorAll('[data-kd-search-open]');
  var searchPanel = document.querySelector('[data-kd-search-panel]');
  var searchCloseBtn = searchPanel ? searchPanel.querySelector('[data-kd-search-close]') : null;
  var searchInput = searchPanel ? searchPanel.querySelector('[data-kd-search-input]') : null;

  function openSearchPanel() {
    if (!searchPanel) return;
    searchPanel.classList.add('is-active');
    if (searchInput) {
      window.setTimeout(function () {
        searchInput.focus();
      }, 80);
    }
  }

  function closeSearchPanel() {
    if (!searchPanel) return;
    searchPanel.classList.remove('is-active');
  }

  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', openSearchPanel);
  });
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearchPanel);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && searchPanel && searchPanel.classList.contains('is-active')) {
      closeSearchPanel();
    }
  });

  function closeSidebar() {
    sidebar.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('kd-sidebar-locked');
    resetNavPanels();
    closeSearchPanel();
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      var isOpen = sidebar.classList.contains('is-open');
      if (isOpen) {
        closeSidebar();
      } else {
        openSidebar();
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && sidebar.classList.contains('is-open')) {
      closeSidebar();
    }
  });

  // Flyout (desktop hover) / accordion (mobile tap) navigation panels.
  var nav = sidebar.querySelector('[data-kd-nav]');
  if (nav) {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var hoverCloseTimer = null;

    // ---- Desktop flyout behavior (UNCHANGED) --------------------------
    function openPanel(targetId, level, triggerEl) {
      var allPanels = sidebar.querySelectorAll('[data-kd-panel]');
      allPanels.forEach(function (panel) {
        var panelLevel = parseInt(panel.getAttribute('data-level'), 10);
        if (panelLevel >= level) {
          panel.classList.remove('is-active');
        }
      });
      if (targetId) {
        var target = document.getElementById(targetId);
        if (target) {
          if (triggerEl && window.matchMedia('(min-width: 990px)').matches) {
            var rect = triggerEl.getBoundingClientRect();
            target.style.paddingTop = Math.max(rect.top, 24) + 'px';
          } else {
            target.style.paddingTop = '';
          }
          target.classList.add('is-active');
        }
      }
    }

    // ---- Mobile accordion behavior (NEW) -------------------------------
    // On mobile/tablet (<990px) tapping a chevron moves that link's panel
    // into the DOM right after its own <li>, so it opens directly beneath
    // the item that was tapped, instead of the desktop full-panel flyout.
    function collapseMobilePanel(panel) {
      if (!panel) return;
      panel.classList.remove('is-active');
      var chevronBtn = panel.previousElementSibling
        ? panel.previousElementSibling.querySelector('.kd-nav-chevron-btn')
        : null;
      if (chevronBtn) chevronBtn.classList.remove('is-open');

      // Collapse any panels open further down inside this one too, so
      // reopening later starts from a clean state.
      var nestedOpenPanels = panel.querySelectorAll('.kd-nav-panel.is-active');
      nestedOpenPanels.forEach(function (nestedPanel) {
        nestedPanel.classList.remove('is-active');
      });
      var nestedOpenChevrons = panel.querySelectorAll('.kd-nav-chevron-btn.is-open');
      nestedOpenChevrons.forEach(function (nestedChevron) {
        nestedChevron.classList.remove('is-open');
      });
    }

    function closeMobileSiblingPanels(li) {
      var ul = li.parentElement;
      if (!ul) return;
      Array.prototype.forEach.call(ul.children, function (siblingLi) {
        if (siblingLi === li) return;
        var openPanel = siblingLi.querySelector('.kd-nav-panel.kd-nav-panel--inline.is-active');
        if (openPanel) collapseMobilePanel(openPanel);
      });
    }

    function toggleMobilePanel(target, chevron, isOpen) {
      if (!target) return;
      var li = chevron.closest('li');

      if (isOpen) {
        collapseMobilePanel(target);
        return;
      }

      if (li) {
        closeMobileSiblingPanels(li);
        if (target.parentElement !== li) {
          li.appendChild(target);
        }
      }

      target.classList.add('kd-nav-panel--inline', 'is-active');
      target.style.paddingTop = '';
      chevron.classList.add('is-open');
    }

    // Links themselves: hover opens the flyout (desktop only). Click is left
    // alone so the link navigates normally to its own URL.
    var triggers = nav.querySelectorAll('[data-kd-flyout-trigger]');
    triggers.forEach(function (trigger) {
      var targetId = trigger.getAttribute('data-target');
      var parentPanel = trigger.closest('[data-kd-panel]');
      var level = parentPanel ? parseInt(parentPanel.getAttribute('data-level'), 10) + 1 : 1;

      if (canHover) {
        trigger.addEventListener('mouseenter', function () {
          if (isMobileViewport()) return;
          clearTimeout(hoverCloseTimer);
          openPanel(targetId, level, trigger);
        });
      }
    });

    // Chevron buttons: click opens/closes the flyout without navigating.
    // Desktop -> existing flyout column. Mobile -> inline accordion.
    var chevrons = nav.querySelectorAll('[data-kd-flyout-chevron]');
    chevrons.forEach(function (chevron) {
      var targetId = chevron.getAttribute('data-target');
      var parentPanel = chevron.closest('[data-kd-panel]');
      var level = parentPanel ? parseInt(parentPanel.getAttribute('data-level'), 10) + 1 : 1;

      chevron.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var target = document.getElementById(targetId);
        var isOpen = target && target.classList.contains('is-active');

        if (isMobileViewport()) {
          toggleMobilePanel(target, chevron, isOpen);
        } else {
          openPanel(isOpen ? null : targetId, level, chevron.previousElementSibling || chevron);
        }
      });
    });

    var backButtons = nav.querySelectorAll('[data-kd-panel-back]');
    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-kd-panel]');
        if (isMobileViewport()) {
          collapseMobilePanel(panel);
          return;
        }
        var level = parseInt(panel.getAttribute('data-level'), 10);
        openPanel(null, level);
      });
    });

    if (canHover) {
      var allPanelEls = nav.querySelectorAll('[data-kd-panel]');
      allPanelEls.forEach(function (panelEl) {
        panelEl.addEventListener('mouseenter', function () {
          if (isMobileViewport()) return;
          clearTimeout(hoverCloseTimer);
        });
        panelEl.addEventListener('mouseleave', function () {
          if (isMobileViewport()) return;
          hoverCloseTimer = setTimeout(resetNavPanels, 220);
        });
      });
    }
  }

  // Keep the cart count in sync with Dawn's cart pubsub events — updates
  // both the in-sidebar badge and the closed-state mobile top bar badge.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var itemCount =
        event && event.cartData && typeof event.cartData.item_count !== 'undefined'
          ? event.cartData.item_count
          : null;
      if (itemCount === null) return;
      var countEls = document.querySelectorAll('.kd-sidebar__cart-badge, .kd-mobile-bar__cart-badge');
      countEls.forEach(function (el) {
        el.textContent = itemCount;
      });
    });
  }
})();
